import { store } from "~/state/store";
import { getMapContentStoreId } from "../utils";
import { IWasmStoreMarker } from "./interfaces";
import { addMarker, removeMarker, updateMarker } from "~/state/map-content/state";
import { addClickEventToStoreItem, addHoverEventToStoreItem, removeAllEventsFromStoreItem, TStoreEventClickCallback, TStoreEventHoverCallback } from "./events";

export default class WasmStoreMarker {
	_data: IWasmStoreMarker;

	constructor(opts: Partial<IWasmStoreMarker>) {
		this._data = {
			id: getMapContentStoreId(),
			lon: 0,
			lat: 0,
			img: "",
			visual: "standard",
			draggable: false,
			lastChange: 0,
			bringToTheFront: false,
			type: "small",
			visible: true,
			customData: null,
			zIndex: null,
			angle: 0,
			callback: "none",
			...opts,
		};
		// store
		store.dispatch(addMarker(this._data));
	}

	onClick(cb: TStoreEventClickCallback) {
		addClickEventToStoreItem(this._data.id, cb);
	}

	onHover(cb: TStoreEventHoverCallback) {
		addHoverEventToStoreItem(this._data.id, cb);
	}

	update(updData: Partial<IWasmStoreMarker>) {
		const changes = {
			...updData,
			lastChange: this._data.lastChange + 1,
		};

		this._data = {
			...this._data,
			...changes,
		};

		// store
		store.dispatch(updateMarker({
			id: this._data.id,
			data: changes,
		}));
	}

	get id() {
		return this._data.id;
	}

	get data() {
		return this._data;
	}

	destroy() {
		removeAllEventsFromStoreItem(this._data.id);
		// store
		store.dispatch(removeMarker(this._data.id));
	}
}
